import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Carousel from './Carousel';
import Slide from './Slide';
import {
  getCarouselSlideCount,
  getSliceHeaderAspect,
  getSliceMobileHeaderAspect,
  getStrictAspects,
  getSliceAnchorId,
  getSliceContent,
} from '../../selectors';
import range from '../../helpers/range';
import get from '../../helpers/get';

const Header = ({
  aspects, contentTopBiases, sliceId, slideCount, ...props
}) => (
  <Carousel sliceId={sliceId} aspects={aspects} {...props}>
    {range(slideCount).map(i => (
      <Slide
        key={i} // eslint-disable-line react/no-array-index-key
        carouselId={sliceId}
        slideIndex={i}
        contentTopBiases={contentTopBiases}
      />
    ))}
  </Carousel>
);

Header.propTypes = {
  aspects: PropTypes.shape({
    mobile: PropTypes.number.isRequired,
    desktop: PropTypes.number.isRequired,
  }).isRequired,
  defaultAspects: PropTypes.shape({
    mobile: PropTypes.number.isRequired,
    desktop: PropTypes.number.isRequired,
  }).isRequired,
  strictAspects: PropTypes.shape({
    mobile: PropTypes.number,
    desktop: PropTypes.number,
  }),
  contentTopBiases: PropTypes.objectOf(PropTypes.number),
  padBottom: PropTypes.bool,
  hidePipsOnMobile: PropTypes.bool,
  sliceId: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
};

Header.defaultProps = {
  contentTopBiases: undefined,
  padBottom: true,
  hidePipsOnMobile: false,
  strictAspects: undefined,
};

const mapStateToProps = (state, { sliceId, defaultAspects, strictAspects }) => ({
  slideCount: getCarouselSlideCount(state, sliceId),
  hidePipsOnMobile: get(getSliceContent(state, sliceId), ['hide_pips_on_mobile']) !== 'No',
  padBottom: get(getSliceContent(state, sliceId), ['pad_bottom']) !== 'No',
  anchorId: getSliceAnchorId(state, sliceId),
  aspects: {
    /* eslint-disable max-len */
    desktop: getStrictAspects(strictAspects, 'desktop') || getSliceHeaderAspect(state, sliceId) || defaultAspects.desktop,
    mobile: getStrictAspects(strictAspects, 'mobile') || getSliceMobileHeaderAspect(state, sliceId) || defaultAspects.mobile,
  },
});

export default connect(mapStateToProps)(Header);
